import { Tooltip, Typography } from '@mui/material';
import { ClipboardList } from 'lucide-react';
import React from 'react';
import { IconWithLabel, TableColumn } from '../../../../ui';
import type { IAssessmentRow } from '../interfaces';
import { formatDashboardDate } from './formatDashboardDate';

const NUMERIC_TITLES: string[] = ['Assigned', 'Completed', 'Expired', 'Shortlisted', 'Unsuccessful'];

const isDateTitle = (title: string): boolean => title === 'Start Date' || title === 'End Date';

export const getAssessmentColumns = (onView?: (row: IAssessmentRow) => void): TableColumn<IAssessmentRow>[] => {
  const titles: string[] = [
    'Assessment Title',
    'Assigned',
    'Completed',
    'Expired',
    'Shortlisted',
    'Unsuccessful',
    'Start Date',
    'End Date',
  ];

  return titles.map((title) => ({
    key: title,
    label: title,
    width: title === 'Assessment Title' ? '260px' : '140px',
    align: 'left' as const,
    render: (row: IAssessmentRow) => {
      if (title === 'Assessment Title') {
        const value = row['Assessment Title'] || '—';
        return (
          <IconWithLabel
            label={value}
            icon={<ClipboardList size={16} />}
            onClick={onView ? () => onView(row) : undefined}
            maxWidth={220}
          />
        );
      }
      if (NUMERIC_TITLES.includes(title)) {
        const value = row[title as keyof IAssessmentRow];
        if (value === undefined || value === null || value === '') {
          return (
            <Typography variant="body2" color="text.disabled" align="left">
              —
            </Typography>
          );
        }
        return (
          <Typography
            variant="body2"
            fontWeight={600}
            align="left"
            sx={{ fontVariantNumeric: 'tabular-nums' }}
          >
            {String(value)}
          </Typography>
        );
      }
      const raw = row[title as keyof IAssessmentRow];
      const display = isDateTitle(title) ? formatDashboardDate(raw as string) : String(raw ?? '—');
      return (
        <Tooltip title={display} arrow placement="top">
          <Typography variant="body2" noWrap align="left" sx={{ maxWidth: 200 }}>
            {display}
          </Typography>
        </Tooltip>
      );
    },
  }));
};
